import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-forest bg-forest-dark py-12 text-sand" data-id="element-14">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-15">
        <p className="font-serif text-xl font-bold text-white" data-id="element-16">
          MEGAPACK PETRÓLEO Y GAS LISTO™
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed" data-id="element-17">
          Hecho por especialistas, para docentes de petróleo y gas, energía y
          técnicas industriales de toda Argentina.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm font-semibold leading-relaxed text-gold" data-id="element-18">
          “La próxima clase que des, podés entrar al aula sabiendo que Argentina
          tiene una de las mayores reservas de shale gas del planeta.”
        </p>
        <a href="mailto:packcentral23@gmail.com" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-gold hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-19">
          <MailIcon className="h-4 w-4" data-id="element-20" /> packcentral23@gmail.com
        </a>
        <p className="mt-8 border-t border-forest pt-6 text-xs text-sand/55" data-id="element-21">
          © 2026 MEGAPACK PETRÓLEO Y GAS LISTO™ · Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}